import GridModel from './gridmodel';
import formatDate from '../utils/formatdate';

const CareerModel = GridModel.extend({
  idAttribute: 'positionId',
  initialize(opts) {
    GridModel.prototype.initialize.call(this);
    this.set({
      createDate: formatDate(this.get('createDate')),
      effectiveDate: formatDate(this.get('effectiveDate'))
    });
  }
});

export default CareerModel;
